import capabilityGraph from "../../extrapolated-graph/extrapolatedGraphData.json"
import { METRIC_FORK_YEAR, type MetricScenarioSeries, type SeriesPoint } from "./metricDetailsTypes"

// AI Capabilities is sampled LIVE from the runtime capability graph data
// (extrapolatedGraphData.json — the same `shared` trunk and per-plan curves the
// main HUD graph draws), so the explainer chart can never drift from the model.
// One reading per whole year; observed 2024–25, shared projection bridged to
// Plan A's fork-year split, branches from the per-plan curves (Default truncated
// at 2033, where it has already pinned to the model's ceiling).
type DatedValue = { date: string; value: number }
const decimalYear = (date: string) => Number(date.slice(0, 4)) + (Number(date.slice(5, 7)) - 1) / 12
const sampleAnnual = (points: DatedValue[], minYear: number, maxYear: number): SeriesPoint[] => {
  const out: SeriesPoint[] = []
  for (let year = minYear; year <= maxYear; year++) {
    let best: DatedValue | null = null
    for (const p of points) {
      if (!best || Math.abs(decimalYear(p.date) - year) < Math.abs(decimalYear(best.date) - year)) best = p
    }
    if (best) out.push({ year, value: best.value })
  }
  return out
}
const shared = capabilityGraph.shared as DatedValue[]
const planA = capabilityGraph.planA as DatedValue[]
const planD = capabilityGraph.planD as DatedValue[]

export const CAPABILITY_SERIES: MetricScenarioSeries = {
  observed: [{ year: 2024, value: 1.0 }, ...sampleAnnual(shared, 2025, 2025)],
  projection: [
    ...sampleAnnual(shared, 2025, METRIC_FORK_YEAR - 1),
    ...sampleAnnual(planA, METRIC_FORK_YEAR, METRIC_FORK_YEAR),
  ],
  branches: {
    A: sampleAnnual(planA, METRIC_FORK_YEAR, 2040),
    D: sampleAnnual(planD, METRIC_FORK_YEAR, 2033),
  },
}
